// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import styles from './FollowSellerLink.module.scss';

type Props = {
    children: React.Node,
    followed: boolean,
};

const FollowSellerLink = ({ children, followed = false }: Props) => {
    if (children) {
        return (
            <span key={0} className={styles['follow-seller']}>
                {children}
            </span>
        );
    }

    return (
        <span key={0} className={styles['follow-seller']}>
            {followed ? <FormattedMessage id="following_auctioneer" /> : <FormattedMessage id="follow_auctioneer" />}
        </span>
    );
};

export default React.memo<Props>(FollowSellerLink, isEqual);
